/**
 * Example JavaScript singleton module
 */

var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    const slides = gsap.utils.toArray(".nosotros-valores__slide");

    slides.forEach((slide, i) => {
      if (i === 0) {
        // La primera slide aparece directamente
        gsap.set(slide, {
          y: 0,
          opacity: 1,
          zIndex: 1
        });
      } else {
        // Las demás aparecen con animación
        const timeline = gsap.timeline({
          scrollTrigger: {
            trigger: ".nosotros-valores",
            start: () => `top -${(i - 0.5) * window.innerHeight}`,
            end: () => `top -${(i + 0.5) * window.innerHeight}`,
            scrub: true
          }
        });

        timeline.to(slide, {
          y: 0,
          opacity: 1,
          zIndex: i + 1,
          duration: 1.5,
          ease: "power1.out"
        });

        const leftContent = slides[i - 1].querySelector(
          ".nosotros-valores--left"
        );
        if (leftContent) {
          timeline.to(
            leftContent,
            {
              opacity: 0,
              duration: 0.5,
              ease: "power2.out"
            },
            "-=0.5"
          );
        }
      }
    });
  }

  function initHorizontalScroll() {
    gsap.registerPlugin(ScrollTrigger);
    const container = document.querySelector(".home-intro");
    const blocksWrapper = container.querySelector(".home-intro-blocks");

    const gap = blocksWrapper.offsetWidth * 0.04;
    const totalScroll = blocksWrapper.scrollWidth;
    const viewportWidth = window.innerWidth;
    const scrollDistance = totalScroll - viewportWidth + gap;

    gsap.to(blocksWrapper, {
      x: () => `-${scrollDistance}px`,
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "top top",
        end: () => `+=${scrollDistance}`,
        scrub: true,
        pin: true,
        anticipatePin: 1
      }
    });
  }

  function initContactBg() {
    ScrollTrigger.create({
      trigger: "#footer",
      start: "top 15%", // cuando el top del footer llega al bottom del viewport
      end: "bottom bottom", // opcional, para eliminar la clase
      toggleClass: {
        targets: ".header",
        className: "header--inverted"
      },
      // Opcional: si quieres que se repita cada vez que se entra/sale
      toggleActions: "play reverse play reverse",
      markers: false // cambia a true si quieres depurar
    });
  }

  function initOrderBox() {
    // var $video = $("#home-order-video");
    // var video = $video[0]; // DOM element

    // $video.on("loadedmetadata", function() {
    //   var duration = video.duration;

    //   ScrollTrigger.create({
    //     trigger: ".home-order",
    //     start: "top 120px",
    //     end: () => "+=" + window.innerHeight * 1.5, // ajusta si quieres que dure más/menos
    //     scrub: true,
    //     pin: true,
    //     onUpdate: function(self) {
    //       var progress = self.progress;
    //       video.currentTime = progress * duration;
    //     }
    //   });
    // });
    const images = gsap.utils.toArray(".home-order-bg__image");
    const numFrames = images.length;
    let currentFrame = -1;

    ScrollTrigger.create({
      trigger: ".home-order",
      start: "top 100px",
      end: () => "+=" + window.innerHeight * 2, // ajusta duración del scroll
      scrub: true,
      pin: true,
      onUpdate: self => {
        const progress = self.progress;

        // Asegúrate de que en 100% del scroll se muestre el último frame
        let frameIndex = Math.floor(progress * numFrames);
        if (frameIndex >= numFrames) {
          frameIndex = numFrames - 1;
        }

        if (frameIndex !== currentFrame) {
          currentFrame = frameIndex;

          // Oculta todas las imágenes
          images.forEach(img => img.classList.remove("is-visible"));

          // Muestra solo la correspondiente
          if (images[frameIndex]) {
            images[frameIndex].classList.add("is-visible");
          }
        }
      }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".main").length) {
      return;
    }

    initGsap();

    if ($("body.home").length) {
      initHorizontalScroll();
      initOrderBox();
    }
    initContactBg();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
